// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'

const HostInformationImage = styled.div`
  background: ${Colors.grayD};
  color: ${Colors.white};
  text-align: center;
  display: inline-block;
  overflow: hidden;
  ${({ small }) =>
    small &&
    css`
      width: 32px;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      font-size: 16px;
    `}
   ${({ medium }) =>
     medium &&
     css`
       width: 40px;
       height: 40px;
       line-height: 40px;
       border-radius: 20px;
       font-size: 20px;
     `}
  ${({ large }) =>
    large &&
    css`
      width: 56px;
      height: 56px;
      line-height: 56px;
      border-radius: 28px;
      font-size: 28px;
    `}
  ${({ huge }) =>
    huge &&
    css`
      width: 80px;
      height: 80px;
      line-height: 80px;
      border-radius: 40px;
      font-size: 40px;
    `}
`
const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
`

export type PropTypes = {
  small?: boolean,
  medium?: boolean,
  large?: boolean,
  huge?: boolean,
  src?: ?string,
  alt?: string,
}

export default function UserIcon(props: PropTypes) {
  return (
    <HostInformationImage
      small={props.small}
      medium={props.medium}
      large={props.large}
      huge={props.huge}
    >
      {props.src ? (
        <Image src={props.src} alt={props.alt} />
      ) : (
        <i className="fa fa-user" />
      )}
    </HostInformationImage>
  )
}



// WEBPACK FOOTER //
// ./src/components/atoms/UserIcon/index.jsx